import contextActionTypes from 'src/modules/shared/context/actionTypes';
import { navigateTo } from 'src/utils/router';
import { close } from 'src/modules/websockets/initWebsockets';

const router = () => next => action => {
  const result = next(action);
  switch (action.type) {
    case contextActionTypes.LOGOUT_SUCCESS:
      close();
      navigateTo('/');
      break;
    default:
      break;
  }

  return result;
};

export default router;
